import CacheBase from '../../../../obsolete/CacheBase';
import logService from '../../../../services/wss/logService3';

const _name = 'TopicGroupCache';

class TopicGroupCache extends CacheBase {
    /**
     * Replaces the groups list in cache.
     * @param {Array} groups
     */
    setGroups = (groups) => {
        this.setCache(groups);
    };

    getGroups = () => {
        return this.getAll();
    };

    /**
     * get active groups only
     * @returns list topic group with stateId 0
     */
    getActiveGroups = () => {
        let items = this.getAll();
        if (items.length === 0) return [];

        items = items.filter((x) => x.stateId === 0);
        return items;
    };

    addGroup = (group) => {
        const current = this.getAll();
        this.setCache([...current, group]);
    };

    updateGroup = (group) => {
        try {
            if (!group) {
                logService.logError(`${_name}.updateGroup: Group is undefined!`);
                return false;
            }

            const existing = this._items.findIndex((g) => g.rk === group.rk);
            if (existing < 0) {
                return false;
            }

            this._items[existing] = group;
            return true;
        } catch (error) {
            logService.logError(`${_name}.updateGroup: ${error.message}`);
            return false;
        }
    };

    /**
     * Updates activeNodeId and activeEntryId on a group in cache.
     * Called by TopicGroupEngine when OnSelectedEntryData is received.
     * @param {OnSelectedEntryData} data - { rk, nid, eid }
     */
    setActiveEntry = (data) => {
        const group = this._items.find((g) => g.rk === data.rk);
        if (!group) return;
        group.activeNodeId = data.nid;
        group.activeEntryId = data.eid;
    };
}

const topicGroupCache = new TopicGroupCache();
export default topicGroupCache;
